import React, { useEffect, useRef, useState } from "react";
import "./Services.css";

const SERVICES_DATA = [
  {
    id: 1,
    category: "Swedish Massage",
    services: [
      {
        name: "Swedish Massage",
        duration: "60 min",
        price: "$95.00",
        description: "Use massage oils or lotions to facilitate smooth, gliding strokes over the entire body",
        features: ["Full Body Coverage", "Smooth Gliding Strokes", "Aromatherapy Oils", "Deep Relaxation"]
      },
      {
        name: "Swedish Massage",
        duration: "90 min",
        price: "$120.00",
        description: "Use massage oils and lotions to facilitate smooth, gliding strokes over the entire body",
        features: ["Extended Full Body", "Enhanced Relaxation", "Premium Oils", "Deeper Experience"]
      },
      {
        name: "Swedish Massage",
        duration: "120 min",
        price: "$140.00",
        description: "Use of massage lotion to provide smooth, gliding strokes for a customized massage for back, neck, legs, feet, arms, hands & gluts, scalp and face upon request",
        features: ["Customized Treatment", "Scalp & Face Massage", "Full Body Focus", "Premium Lotion"]
      }
    ]
  },
  {
    id: 2,
    category: "Deep Tissue",
    services: [
      {
        name: "Deep Tissue",
        duration: "60 min",
        price: "$100.00",
        description: "Deeper pressure applied to release muscle tension in the deeper levels of the muscles, also breaks up scar tissue",
        features: ["Deep Pressure", "Muscle Tension Relief", "Scar Tissue Breakdown", "Therapeutic Focus"]
      },
      {
        name: "Deep Tissue",
        duration: "90 min",
        price: "$130.00",
        description: "Deeper pressure applied to release muscle tension in the deeper levels of the muscles, also breaks up scar tissue",
        features: ["Extended Treatment", "Chronic Tension Relief", "Deep Muscle Work", "Injury Recovery"]
      },
      {
        name: "Deep Tissue Massage",
        duration: "120 min",
        price: "$150.00",
        description: "Warm tissue with Swedish strokes, deep pressure is applied to muscles to ease knots and increase circulation as well as movement",
        features: ["Swedish Warm-up", "Knot Relief", "Improved Circulation", "Enhanced Movement"]
      }
    ]
  },
  {
    id: 3,
    category: "Cupping Therapy",
    services: [
      {
        name: "Cupping Therapy",
        duration: "60 min",
        price: "$105.00",
        description: "Use of silicone cups or plastic cups with suction applied to the tissue creating suction of soft tissue, helps with pain, tightness, inflammation, blood flow and relaxation",
        features: ["Pain Relief", "Reduce Tightness", "Decrease Inflammation", "Improve Blood Flow"]
      },
      {
        name: "Cupping Therapy",
        duration: "90 min",
        price: "$120.00",
        description: "Use of silicone cups or plastic cups with suction applied to the tissue creating suction of soft tissue, helps with pain, tightness, inflammation, blood flow and relaxation",
        features: ["Extended Treatment", "Deeper Relief", "Enhanced Recovery", "Maximum Relaxation"]
      }
    ]
  },
  {
    id: 4,
    category: "Specialty Services",
    services: [
      {
        name: "Seated Chair Massage",
        duration: "20 min",
        price: "$20.00",
        description: "Fully clothed, you sit in a massage chair and have head, neck, back, arms, legs massaged. Perfect for office employees.",
        features: ["Fully Clothed", "Quick Relief", "Office Friendly", "Targeted Areas"]
      },
      {
        name: "Hot Bamboo Massage",
        duration: "60 min",
        price: "$125.00",
        description: "Immerse yourself in deep relaxation with hot Bamboo. Several different sizes are used to target muscles groups and increase lymphatic drainage.",
        features: ["Deep Relaxation", "Lymphatic Drainage", "Warm Therapy", "Muscle Targeting"]
      },
      {
        name: "Hot Bamboo Massage",
        duration: "90 min",
        price: "$135.00",
        description: "Hot Bamboo in various shapes used to target areas of need, with longer time this deep relaxation can maximize and lengthen effects long after your massage.",
        features: ["Extended Therapy", "Deep Tissue Work", "Long-lasting Effects", "Premium Experience"]
      },
      {
        name: "Deep Tissue Express",
        duration: "30 min",
        price: "$50.00",
        description: "Experience targeted relief with our 30-minute deep tissue massage, designed to address specific muscle groups using guasha techniques and deep pressure.",
        features: ["Quick Session", "Targeted Relief", "Guasha Techniques", "Muscle Recovery"]
      }
    ]
  },
  {
    id: 5,
    category: "Animal Massage",
    services: [
      {
        name: "Animal Massage",
        duration: "30 min",
        price: "$50.00",
        description: "Massage techniques applied to animal muscles to increase mobility, increase blood flow and increase healing. House Call Service",
        features: ["House Call", "Increase Mobility", "Improve Blood Flow", "Speed Healing"]
      },
      {
        name: "Animal Massage",
        duration: "60 min",
        price: "$75.00",
        description: "Massage techniques applied to animal muscles to increase mobility, increase blood flow and increase healing. House Call Service",
        features: ["Extended Session", "Deeper Treatment", "Maximum Benefits", "House Call Included"]
      }
    ]
  }
];

export default function Services() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState(0);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const openBookingLink = () => {
    window.open('https://mysite.vagaro.com/apeacefulretreat', '_blank');
  };

  // Mobile travel note for chair massage
  const travelNote = "$1.00 a minute charge, $2 per mile. Also can do at office, on nice days outside is an option.";

  return (
    <section className="services" id="services" ref={sectionRef}>
      {/* Background Elements */}
      <div className="services__bg-elements" aria-hidden="true">
        <div className="services__bg-shape services__bg-shape--1"></div>
        <div className="services__bg-shape services__bg-shape--2"></div>
        <div className="services__bg-shape services__bg-shape--3"></div>
      </div>

      <div className="services__container">
        {/* Header Section */}
        <div className={`services__header ${isVisible ? 'is-visible' : ''}`}>
          <div className="services__ornament" aria-hidden="true">
            <div className="services__ornament-line"></div>
            <div className="services__ornament-dot"></div>
            <div className="services__ornament-line"></div>
          </div>
          
          <h1 className="services__title">
            <span className="services__title-line">Professional Massage</span>
            <span className="services__title-line services__title-line--accent">& Wellness Services</span>
          </h1>
          
          <p className="services__subtitle">
            Experience transformative healing with expertly crafted massage therapies and specialized treatments. 
            Each session is personalized to meet your unique needs and promote overall well-being.
          </p>
        </div>

        {/* Category Navigation */}
        <div className={`services__categories ${isVisible ? 'is-visible' : ''}`}>
          <div className="services__categories-container">
            {SERVICES_DATA.map((category, index) => (
              <button
                key={category.id}
                className={`services__category-tab ${activeCategory === index ? 'is-active' : ''}`}
                onClick={() => setActiveCategory(index)}
              >
                <span className="services__category-text">{category.category}</span>
                <div className="services__category-indicator"></div>
              </button>
            ))}
          </div>
        </div>

        {/* Services Grid */}
        <div className="services__content">
          {SERVICES_DATA.map((category, categoryIndex) => (
            <div 
              key={category.id}
              className={`services__category ${categoryIndex === activeCategory ? 'is-active' : ''}`}
            >
              <div className="services__grid">
                {category.services.map((service, serviceIndex) => (
                  <article 
                    key={serviceIndex}
                    className={`service-card ${isVisible ? 'is-visible' : ''}`}
                    style={{ animationDelay: `${serviceIndex * 0.1}s` }}
                  >
                    {/* Card Glow Effect */}
                    <div className="service-card__glow" aria-hidden="true"></div>
                    
                    {/* Card Corners */}
                    <div className="service-card__corner service-card__corner--tl" aria-hidden="true"></div>
                    <div className="service-card__corner service-card__corner--br" aria-hidden="true"></div>

                    <div className="service-card__content">
                      {/* Service Header */}
                      <div className="service-card__header">
                        <div className="service-card__info">
                          <h3 className="service-card__name">{service.name}</h3>
                          <div className="service-card__meta">
                            {service.duration && (
                              <span className="service-card__duration">{service.duration}</span>
                            )}
                            {service.price && (
                              <span className="service-card__price">{service.price}</span>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Service Description */}
                      <p className="service-card__description">{service.description}</p>

                      {/* Travel Note for Chair Massage */}
                      {service.name === "Seated Chair Massage" && (
                        <p className="service-card__travel-note">{travelNote}</p>
                      )}

                      {/* Service Features */}
                      <div className="service-card__features">
                        <h4 className="service-card__features-title">Key Benefits:</h4>
                        <ul className="service-card__features-list">
                          {service.features.map((feature, idx) => (
                            <li key={idx} className="service-card__feature">
                              <span className="service-card__feature-icon">•</span>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* CTA Button */}
                      <div className="service-card__footer">
                        <button 
                          className="service-card__cta"
                          onClick={openBookingLink}
                          aria-label={`Book ${service.name} session`}
                        >
                          <span className="service-card__cta-text">Book Now</span>
                          <div className="service-card__cta-icon">
                            →
                          </div>
                          <div className="service-card__cta-shine"></div>
                        </button>
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Military Discount Banner */}
        <div className={`services__military-banner ${isVisible ? 'is-visible' : ''}`}>
          <div className="services__military-banner-content">
         
            <p className="services__military-text">
              We offer a <span className="services__military-highlight">$10 Military Discount</span> on any service
            </p>
       
          </div>
        </div>
      </div>
    </section>
  );
}